export type SettingModelSettingType = (typeof SettingModelSettingType)[keyof typeof SettingModelSettingType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingModelSettingType = {
    Panels: 'Panels',
    Connectors: 'Connectors',
    Corners: 'Corners',
    StopEnd: 'StopEnd'
} as const;
